import React from "react";


const Testimonials = ({sectionTitle,testimonialsData,language}) => {
  const testimonials = testimonialsData[language];
  return (
    <div className="container my-5" dir={language === "ar" ? "rtl" : "ltr"}>

      <h2 className="text-center mb-5 mt-5" style={{ fontFamily: "Libre Caslon Display, serif" ,fontWeight:"600"}}>
        {sectionTitle}
      </h2>

      <div className="row justify-content-center text-center">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="col-md-4 mb-4 px-3">
            <div className="mb-2">
              {[...Array(5)].map((_, i) => (
                <span key={i} style={{ color: "#F8C49D", fontSize: "20px" }}>★</span>
              ))}
            </div>
            <p className="text-muted fw-medium" style={{ fontSize: "16px", lineHeight: "1.8" }}>
              {testimonial.message}
            </p>
            <img
              src={testimonial.image}
              alt={testimonial.name}
              className="rounded-circle mt-3 mb-2"
              style={{ width: "60px", height: "60px", objectFit: "cover" }}
            />
            <div className="text-uppercase fw-bold" style={{ letterSpacing: "1px", fontSize: "12px" }}>
              {testimonial.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
